import * as React from "react";
const SvgFiRrDocumentSigned = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-document-signed_svg__a)">
      <path
        fill="#062147"
        d="m19.535 3.122-1.656-1.658A4.97 4.97 0 0 0 14.343 0H8a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h8a5.006 5.006 0 0 0 5-5V6.657a4.97 4.97 0 0 0-1.465-3.535m-1.414 1.414q.213.212.379.464H16V2.5a3 3 0 0 1 .465.38zM19 19a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6v3a2 2 0 0 0 2 2h3zM16 9a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm1 5a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1m-.192 3.413a1 1 0 0 1-.217 1.394A6.46 6.46 0 0 1 13.135 20a3.25 3.25 0 0 1-2-.7c-.328-.225-.453-.3-.7-.3-.669.104-1.3.377-1.832.794a1 1 0 0 1-1.214-1.588A5.86 5.86 0 0 1 10.439 17c.666.01 1.31.24 1.832.655.238.214.544.336.864.345a4.6 4.6 0 0 0 2.277-.809 1 1 0 0 1 1.396.222"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-document-signed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDocumentSigned;
